import _ from 'underscore';
import React, { ComponentType, useState, useCallback, useContext } from 'react';
import { PreferenceContext } from '@bingads-webui-react/preference-context';

import { TopLocationsCardProps } from '../utils/types';

const cardId = 'CardType-TopLocations';

type WithMetricProps = {
  preferenceFromServer?: string;
  patchPreference?: Function;
  logOnClick: Function;
} & TopLocationsCardProps;

export function withPMaxPreferencesMetric<P extends WithMetricProps>(WrappedComponent: ComponentType<P>): ComponentType<Omit<P, 'metric' | 'onMetricChange'>> {
  const HoC = (props) => {
    const {
      preferenceFromServer,
      patchPreference,
      logOnClick,
    } = props;
    const preferenceService = useContext(PreferenceContext) as any;
    const preferences = preferenceService.findByName('dashboard/preferences');
    const cardPreferences = preferences?.Data?.['default-campaign-performancemax']?.cards || [];
    const currentCardPreferences: any = _.find(cardPreferences, (card: any) => card.id === cardId);
    const initMetric = currentCardPreferences?.options?.metric ?? 'Clicks';
    const [metric, setMetric] = useState(preferenceFromServer || initMetric);

    const onMetricChange = useCallback((newMetric: string) => {
      logOnClick('onMetricChange');
      setMetric(newMetric);

      if (patchPreference) {
        patchPreference({ metric: newMetric });
        return;
      }

      let cards;
      if (!_.find(cardPreferences, (card: any) => card.id === cardId)) {
        cards = [...cardPreferences, { id: cardId, options: { metric: newMetric } }];
      } else {
        cards = cardPreferences.map((card) => {
          if (card.id === cardId) {
            return {
              ...card,
              options: {
                ...card.options,
                metric: newMetric,
              },
            };
          }
          return card;
        });
      }
      const preferencesData = preferences?.Data || {};
      preferenceService.set({
        Name: 'dashboard/preferences',
        ...preferences,
        Data: {
          ...preferencesData,
          'default-campaign-performancemax': {
            ...preferencesData['default-campaign-performancemax'],
            cards,
          },
        },
      });
    }, [cardPreferences, patchPreference, preferenceService, preferences]);

    return (<WrappedComponent
      {...props as any}
      metric={metric}
      onMetricChange={onMetricChange}
    />);
  };

  return HoC;
}
